import { Dialog } from "shared/Dialog";
import { MyonApiResponse, isMyonApiSuccess } from "shared/Api/MyonApiResponse";
import { RouteGenerator, HttpClient, Client } from "silver";

export enum TaskType {
	BENCHMARK = 1
}

interface TaskPayload {
	title: string;
	message: string;
	accept: string;
}

interface TaskAvailablePayload extends TaskPayload {
	target: string;
	cancel: string;
}

function isTaskAvailable(payload: TaskPayload): payload is TaskAvailablePayload {
	return payload.hasOwnProperty("target");
}

export class TaskMessage {

	constructor(
		private dialog: Dialog,
		private router: RouteGenerator,
		private httpClient: HttpClient,
		private client: Client
	) { }

	public async message(task: TaskType, sourceElement?: HTMLElement): Promise<void> {
		const url = this.router.generate("api\\userTask", null, { task }, "json");
		const response: MyonApiResponse<TaskPayload> = await this.httpClient.get(url);
		if (!isMyonApiSuccess(response)) {
			return;
		}

		const { title, message, accept } = response.result;
		if (!isTaskAvailable(response.result)) {
			await this.dialog.alert(title, message, accept);
			return;
		}

		const { cancel, target } = response.result;
		if (!await this.dialog.confirm(title, message, accept, cancel, { sourceElement })) {
			return;
		}

		this.client.open(target);
	}
}
